module.exports = __webpack_public_path__ + "img/ld_2@2x.3da05d3f.png";